import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import day from 'dayjs'
import { DatePicker } from 'antd-mobile'
import { formattedDate } from '../../utils/formatDate'
import AiDatePicker from '../AiDatePicker'
import './index.scss'

export const labelRenderer = (type: string, data: number) => {
    switch (type) {
        case 'year':
            return data + '年'
        case 'month':
            return data + '月'
        case 'day':
            return data + '日'
        case 'hour':
            return data + '时'
        case 'minute':
            return data + '分'
        case 'second':
            return data + '秒'
        default:
            return data
    }
}

interface PickerScopeProps {
    onConfirm?:(value) => void
    children?:React.ReactNode | string // 右上角的图标
    startTitle?:string
    endTitle?:string
    dateList?:string[]
    min?: any
    max?: any
    disabled?: boolean //是否禁用
}

export const PickerScope = ({disabled = false, min = new Date(), startTitle = '选择开始日期', endTitle = '选择结束日期', max = new Date('2050-01-01'), dateList = [], ...props}:PickerScopeProps) => {
    const [startDate, setStartDate] = useState('')
    const [endtDate, setEndtDate] = useState('')
    
    const { pathname } = useLocation();
    useEffect(()=>{ 
        AiDatePicker.destroy()
	},[])
    const handleClickPrcker = () => {
        try {
            if( disabled ) {
                return
            }
            const defaultValue = dateList[0] ? new Date(dateList[0]) : null
            setStartDate('')
            setEndtDate('')
            AiDatePicker.prompt({
                title:startTitle,
                min:min || new Date(),
                max,
                defaultValue,
                renderLabel:labelRenderer.bind(this),
                onConfirm:val => {
                    try {
                        const _ = day(val).format('YYYY-MM-DD')
                        setStartDate(_)
                        handleChangeEndDate(_)
                    } catch (error) {
                        console.log(error)
                    }
                }
            })
        } catch (error) {
            
        }
    }
    const handleChangeEndDate = async(min) => {
        try {
            AiDatePicker.prompt({
                title:endTitle,
                max,
                min:new Date(min),
                renderLabel:labelRenderer.bind(this),
                onConfirm:val => {
                    const endDate = day(val).format('YYYY-MM-DD')
                    setEndtDate(endDate)
                    props?.onConfirm && props.onConfirm([min,endDate])
                }
            })
        } catch (error) {
            
        }
    }
    return <div onClick={handleClickPrcker} style={{'width':'100%','height':'100%'}}>{props.children}</div>
}

interface AiPickerDateProps {
    onChange?:(value, index) => void
    isTitle?:string
    dateList?:string[]
    children?:React.ReactNode | string // 右上角的图标
    dateId?:number
    _style?:any
    min?: any
    max?: any
    type?: number
}

const AiPickerDate = ({min = new Date('2019-01-01'), isTitle = '', dateList = [], children = '自定义', type = 0,   _style = {}, ...props}:AiPickerDateProps) => {
    const [dateId, setDateId] = useState(props?.dateId || 0)
    const handleChangeDateItem = (index) => {
        setDateId(index)
        if( !!props?.onChange) {
            if( type === 0 ) {
                props.onChange(formattedDate(`${index}`), index)
            }else if(type === 1) {
                if( index === 0 ) {
                    props.onChange([], index)
                }else {
                    let _index:any = '1'
                    switch (index) {
                        case 1: // 昨日
                            _index = '2'
                            break
                        case 2:
                            _index = '3'
                            break
                        case 3:
                            _index = '4'
                            break
                        default:
                    }
                    props.onChange(formattedDate(`${_index}`), index)
                }
            }
        }
    }
    
    useEffect(()=>{ 
        return () => {
            AiDatePicker.destroy()
        }
	},[])
    useEffect(() => {
        setDateId(props?.dateId || 0)
    },[props.dateId])
    const handleConfirm = (value) => {
        setDateId(-1)
        if(props?.onChange) {
            props.onChange(value, -1)
        }
    }
    return <div className="picker-wrapper-date-tabs">
        {isTitle && <span>{isTitle}</span>}
        {(type === 0 ? ['今日', '昨日', '近7天', '近30天'] : ['全部', '近7天', '近30天', '本年']).map((item, index) => (
            <div style={{..._style}} key={index} className={`${dateId === index ? 'active' : ''}`} onClick={() => handleChangeDateItem(index)}>{item}</div>
        ))}
        <PickerScope min={min} max={props?.max || new Date()} onConfirm={handleConfirm} dateList={dateList}>{children}</PickerScope>
    </div>
}


export default AiPickerDate